import { useNavigate } from "react-router-dom";

import { pathGenerators } from "utils/routes";

export const useNavigateToPatient = () => {
  const navigate = useNavigate();

  const navigateToPatient = (e, id) => {
    if (e.button === 1 || e.ctrlKey || e.metaKey) return;
    e.preventDefault();
    e.stopPropagation();

    navigate(pathGenerators.patient.results(id));
  };

  return { navigateToPatient };
};
